module.exports = __webpack_public_path__ + "fonts/webfont.095f951a.ttf";